<div class="postings-swipper-container relative">
    <swiper-container #swiperEl init="false" class="postings-swipper" (slideChangeTransitionEnd)="onSlideChangeTransitionEnd()">
        <swiper-slide
            #postingsRef
            [attr.postId]="postingResource.posting.id"
            *ngFor="let postingResource of featuredWidget.content; index as index; first as isFirst; last as isLast"
            class="slide swiper-slide"
            (click)="openPostInDialog(index, isFirst, isLast)"
            (mouseenter)="onMouseEnter(postingResource.posting, $event)"
            (mouseleave)="onMouseLeave($event)"
            (mousemove)="onMouseMove($event)"
            (keyup.enter)="onMouseEnter(postingResource.posting, $event); onMouseMove($event); openPostInDialog(index, isFirst, isLast)"
            (keyup.escape)="onMouseLeave($event)"
        >
            <div class="slide-wrapper">
                <div class="slide-img-container" (click)="openPostingUrl(postingResource.posting)">
                    <div class="slide-img-layer"></div>
                    <div class="slide-img scale" [style.background-image]="'url(' + postingResource.posting.image.smallUrl + ')'"></div>
                    <div class="slide-content">
                        <mat-chip-set tabIndex="-1">
                            <mat-chip class="accent-500" [disableRipple]="true">{{ postingResource.posting.postingType.displayNameKeySingular | translate }}</mat-chip>
                        </mat-chip-set>
                        <h3 tabindex="0" attr.aria-label="{{ 'GENERAL.BUTTON.OPEN' | translate }} {{ postingResource.posting.translation.title }}">
                            {{ postingResource.posting.translation.title | translate }}
                        </h3>
                    </div>
                </div>

                <div class="slide-hover-data">
                    <div class="slide-img-container">
                        <div class="slide-img-layer"></div>
                        <div class="slide-img" [style.background-image]="'url(' + postingResource.posting.image.smallUrl + ')'"></div>
                    </div>
                    <div class="slide-content">
                        <mat-chip-set tabIndex="-1">
                            <mat-chip class="accent-500" [disableRipple]="true">{{ postingResource.posting.postingType.displayNameKeySingular | translate }}</mat-chip>
                        </mat-chip-set>
                        <h3 tabindex="0">{{ postingResource.posting.translation.title | translate }}</h3>
                        <div class="posting-description" [innerHTML]="postingResource.posting.translation.description | safeHtml"></div>
                        <div class="mt-16 btn-container" fxLayoutAlign="flex-end" *ngIf="postingResource.posting.url">
                            <app-flat-button
                                class="w-full"
                                attr.aria-label="{{ 'GENERAL.LABEL.OPEN_POSTING' | translate }} {{ 'GENERAL.LABEL.ARIA_ACTION' | translate }}"
                                [label]="postingResource.posting.postingType.actionButtonTextKey"
                                (onClick)="openPostingUrl(postingResource.posting)"
                            ></app-flat-button>
                        </div>
                    </div>
                </div>
            </div>
        </swiper-slide>
    </swiper-container>

    <div #nextBtn class="postings-swiper-button-next"></div>
    <div #prevBtn class="postings-swiper-button-prev"></div>
</div>
